module.exports = __webpack_public_path__ + "static/media/wedding-cake.3830c7ba.svg";